import M from 'backbone.marionette'
import T from './programmeSelector.html'


const ProgramOption = M.View.extend({
    template: _.template('<%=programme.Type%> <%=programme.CodeProgramme%> - <%=programme.NomProgramme%>'),
    serializeData: function (model) {
        return {
            inscriptionp: this.model.toJSON(),
            programme: this.getOption('controller').get('programmes').get(this.model.get('NoProgramme')).toJSON()
        }
    },
    tagName: 'option',
    attributes: function () {
        return {
            value: this.model.get('id'),
            selected: this.model.get('id') == this.getOption('controller').get('currentInscriptionP') ? 'selected' : null,
            style: this.model.get('active') ? '' : 'background-color:rgb(255, 202, 202)'
        }
    }
})

const Programmes = M.CollectionView.extend({
    template: _.template(''),
    tagName: 'select',
    className:'form-control',
    childView: ProgramOption,
    childViewOptions: function (model, index) {
        return {
            controller: this.model,
            model: model
        }
    },
    attributes: function(){
        console.log('projectSelector value', this.model.get('currentInscriptionP'))
        return {
            value: this.model.get('currentInscriptionP')
        }
    },
    modelEvents: {
        'change:currentInscriptionP': 'render'
    },
    events: {
        'change':'onChange'
    },
    initialize: function () {
        this.collection = this.model.get('inscriptionp')
    },
    onChange: function(event){
        console.log('onChange event', event);
        this.model.updateCurrentInscriptionP(this.$el.val());
    }
})

export const ProgrammeSelector = M.View.extend({
    template: _.template(T),
    modelEvents: {
        'add inscriptionp':'render',
        'remove inscriptionp':'render',
        'change inscriptionp':'render',
    },
    regions: {
        'programmeSelectorInput': {
            el: '.programmeSelectorInput',
            replaceElement: true,
        }
    },
    onRender: function () {
        if(this.model.get('inscriptionp').length > 1){
            this.$el.show();
            this.showChildView('programmeSelectorInput', new Programmes({
                model: this.model
            }))
        }  else{
            this.$el.hide();
        }
    }
})